/**
 * `/admin/tenant-attributes` — gli attributi chiave/valore dell'azienda, dalla piattaforma.
 *
 * ⚠️ La schermata **non sta qui**: è `TenantAttributesPanel`, perché la rende anche la sezione
 * «Attributi» di «Dati dell'azienda». Questa rotta resta per i link già in giro.
 */
import { createFileRoute } from '@tanstack/react-router';
import { TenantAttributesPanel } from '@/features/tenant-attributes/TenantAttributesPanel';

export const Route = createFileRoute('/_app/admin/tenant-attributes')({
  component: TenantAttributesPanel,
});
